<template>
   <el-row class="container_self">
        <el-row class="main-content"   v-loading="loading"  element-loading-text="加载中，请稍后">
            <el-row class="top_card_content" >
            <el-col :span="4">
                <el-card class="box-card first-card">
                    <h2 style="height:28px;">{{customer}}</h2>
                    <span>客户数量</span>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card class="box-card second-card">
                    <h2 style="height:28px;">{{AppCount}}</h2>
                    <span>App 数量</span>
                </el-card>
            </el-col>
        </el-row>
           <el-row class="eventList">
                <el-row style="height:40px;line-height: 40px;">
                    <h3 style="display:inline-block">事件触发统计</h3>
                    <el-button-group style="float: right;" class="btn-group">
                        <el-button :type="type1" @click="dateChange(1)">本日</el-button>
                        <el-button :type="type2" @click="dateChange(2)">本周</el-button>
                        <el-button :type="type3" @click="dateChange(3)">本月</el-button>
                        <el-button :type="type4" @click="dateChange(4)">本季度</el-button>
                    </el-button-group>
                </el-row>
                <el-row class="event_parent">
                    <el-col :span="4" v-for="(item,index) in eventList" :key="index" class="sm-card-parent">
                        <el-card class="box-card small-card"  @click.native="getEventDetail(item)" :class="currentItem==item.name?'activeItem':''">
                            <h4>{{item.nameText}}</h4>
                            <span>{{item.count}} {{item.unit}}</span>
                        </el-card>
                    </el-col>
                </el-row>
                

                <el-row class="event_chart_parent">
                        <h3>事件趋势图</h3>

                        <el-row id="event_chart" style="width:100%;height:440px"></el-row>
                </el-row>
           </el-row>

        </el-row>
   </el-row>
</template>

<script>
    import { axiosGet } from "@/assets/ajaxFn.js";
    import * as echarts from 'echarts';
    import {formateDate,getFirstDayOfQuarter,getWeekDates,getFirstAndLastDayOfMonth,getLastDayOfQuarter,getDatesBetween,generateTimeArray} from '@/assets/dateUtils.js'
    export default {
        data(){
            return{
                interval:0,
                loading:false,
                customer:'',
                AppCount:'',
                eventList:[
                    {name:'WebsiteLoadError',count:0,nameText:'Website加载错误',unit:'次'},
                    {name:'OpenStarted',count:0,nameText:'Website开始加载',unit:'次'},
                    {name:'SessionTimeInMillisecond',count:0,nameText:'Website停留时长',unit:'秒'},
                    {name:'WebsiteSwitched',count:0,nameText:'Website切换',unit:'次'},
                    {name:'WebViewClicked',count:0,nameText:'WebView点击',unit:'次'},
                    {name:'UserStayTimeInMillisecond',count:0,nameText:'WebView存在时长',unit:'秒'},
                    {name:'TotalWebsitesInSession',count:0,nameText:'WebView加载url数量',unit:'个'}
                ],
                chartsElement:null,
                xData:[],
                yData:[],
                title:'',
                currentItem:'WebsiteLoadError',
                startTime:'',
                endTime:'',
                type1:'primary',
                type2:'default',
                type3:'default',
                type4:'default'
            }
        },
        methods:{
            drawChart(x,y,title){
                this.chartsElement=echarts.init(document.getElementById('event_chart'));
                this.chartsElement.showLoading({
                    text: 'loading',
                    color: '#c23531',
                    textColor: '#000',
                    maskColor: 'rgba(255, 255, 255, 0.2)',
                    zlevel: 0,
                })
                let option = {
                    title: {
                        text: title,
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLabel:{
                            // interval:interval,
                            // showMaxLabel:true
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                        data: y,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',  //取消折点圆圈
                        }
                    ]
                };
                this.chartsElement.setOption(option);
                let _this=this;
                setTimeout(function(){
                    _this.chartsElement.hideLoading();
                },500)
            },
            getEventDetail(item){
                this.title=item.nameText;
                this.currentItem=item.name;
                this.getEventList(this.startTime,this.endTime)
                // this.xData=
            },
            dateChange(val){
                if(val==1){
                    this.startTime=formateDate(new Date());
                    this.endTime=formateDate(new Date());
                    this.type1='primary';
                    this.type2='default';
                    this.type3='default';
                    this.type4='default';
                }else if(val==2){
                    this.interval=1;
                    this.startTime=formateDate(getWeekDates().start);
                    this.endTime=formateDate(getWeekDates().end);
                    this.type1='default';
                    this.type2='primary';
                    this.type3='default';
                    this.type4='default';
                }else if(val==3){
                    this.startTime=formateDate(getFirstAndLastDayOfMonth().firstDay);
                    this.endTime=formateDate(getFirstAndLastDayOfMonth().lastDay);
                    this.type1='default';
                    this.type2='default';
                    this.type3='primary';
                    this.type4='default';
                }else{
                    this.startTime=formateDate(getFirstDayOfQuarter());
                    this.endTime=formateDate(getLastDayOfQuarter());
                    this.type1='default';
                    this.type2='default';
                    this.type3='default';
                    this.type4='primary';
                }
                this.getEventList(this.startTime,this.endTime);
            },
            async getEventList(startTime,endTime){
                try {
                    this.xData=[];
                    this.yData=[];
                    this.loading=true;
                    const res = await axiosGet(`/api/statistics/event?start=${startTime}&end=${endTime}`);
                    if (res.code === 0) {
                        this.loading=false;
                        if (res.data.length) {
                            for (const event of this.eventList) {
                            const { name } = event;
                            const { count = 0 } = res.data.find(item => item.name === name) || {};
                            event.count = count;
                            }
                        } else {
                            this.eventList = [
                            { name: 'WebsiteLoadError', count: 0, nameText: 'Website加载错误', unit: '次' },
                            { name: 'OpenStarted', count: 0, nameText: 'Website开始加载', unit: '次' },
                            { name: 'SessionTimeInMillisecond', count: 0, nameText: 'Website停留时长', unit: '秒' },
                            { name: 'WebsiteSwitched', count: 0, nameText: 'Website切换', unit: '次' },
                            { name: 'WebViewClicked', count: 0, nameText: 'WebView点击', unit: '次' },
                            { name: 'UserStayTimeInMillisecond', count: 0, nameText: 'WebView存在时长', unit: '秒' },
                            { name: 'TotalWebsitesInSession', count: 0, nameText: 'WebView加载url数量', unit: '个' }
                            ];
                        }
                    }
                    const res1=await axiosGet('/api/statistics/event_trend?start='+startTime+'&end='+endTime+'&name='+this.currentItem);
                    this.xData=getDatesBetween(this.startTime,this.endTime);
                    if(res1.code==0){
                        if(res1.data.length){
                           for(var x=0;x<this.xData.length;x++){
                            this.yData.push(0);
                            for(var c=0;c<res1.data.length;c++){
                                if(this.xData[x]===res1.data[c].time){
                                    this.yData[x]=res1.data[c].count;
                                }
                            }
                           }
                           
                           
                        }
                    }
                    console.log(this.xData,this.yData)
                    this.drawChart(this.xData,this.yData,this.title)
                } catch (error) {
                    // 处理错误
                    console.log(error)
                    this.loading=false;
                }
            }
        },
        mounted() {
            axiosGet('/api/statistics/customer').then(res=>{
                if(res.code==0){
                    for(var c=0;c<res.data.length;c++){
                        if(res.data[c].name==='customer'){
                            this.customer=res.data[c].count;
                        }
                        if(res.data[c].name==='app'){
                            this.AppCount=res.data[c].count;
                        }
                    }
                }
            })
            this.xData=generateTimeArray();//默认为当天的
            this.title=this.eventList[0].nameText;
            this.drawChart(this.xData,this.yData,this.title);
            //按钮切换时间默认当日
            this.dateChange(1);
        },
    }
</script>
<style scoped>
  .top_card_content  .box-card{
        color: rgb(255, 255, 255);
        --va-0-stripe-color-computed: #154EC1;
        border-radius:10px;
        margin-right: 25px;
    }
    .first-card{
        background: rgb(67, 163, 7);
    }
    .second-card{
        background: rgb(21, 141, 227);
    }
    .top_card_content{
        margin-bottom:30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/view/index.vue